import React from "react";
import imageOverlay from "../img/earth.jpg";

class Contact extends React.Component {
  render() {
    return (
      <section
        className="paralax-mf footer-paralax bg-image sect-mt4 route"
        style={{ backgroundImage: "url(" + imageOverlay + ")" }}
      >
        <div className="overlay-mf"></div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="contact-mf">
                <div id="contact" className="box-shadow-full">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="title-box-2 pt-4 pt-md-0">
                        <h3 className="title-a text-center">Contact</h3>
                        <div className="line-mf"></div>
                      </div>
                      <div className="more-info">
                        <p className="lead">
                          Tel - 010-5629-9335
                          <br />
                          Mail - hello.ddubbu@gmail.com
                          <br />
                          Github - &nbsp;
                          <a
                            class="href-highlight-orange"
                            href="https://github.com/ddubbu"
                          >
                            바로가기
                          </a>
                          <br />
                          Blog - &nbsp;
                          <a
                            class="href-highlight-orange"
                            href="https://kr-ddubbu.tistory.com/20?category=932301"
                          >
                            바로가기
                          </a>
                        </p>
                      </div>
                      {/* <div className="socials">
                        <ul>
                          <li>
                            <a
                              href=""
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className="ion-social-codepen"></i>
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href=""
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className="ion-social-github"></i>
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href=""
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className="ion-social-linkedin"></i>
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="copyright-box"></div>
              </div>
            </div>
          </div>
        </footer>
      </section>
    );
  }
}

export default Contact;
